import { apiDaInscricao } from "../../../servicos/axios";

export type ApiAgendamentoEmAndamento = {
  id: number;
  dataInicial: string; // ISO
  dateFinal?: string;
  status: string;
  pessoa: {
    nome: string;
    cpf?: string;
    telefoneCelular?: string;
  };
};

export const buscarAgendamentoEmAndamento =
  async (): Promise<ApiAgendamentoEmAndamento | null> => {
    const api = apiDaInscricao();

    const resp = await api.get("/agendamento/EmAtendimento", {
      validateStatus: (s: any) => (s >= 200 && s < 300) || s === 204,
    });

    if (resp.status === 204) return null;
    return (resp.data?.agendamento ?? null) as ApiAgendamentoEmAndamento | null;
  };
